var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voice-bar"},[_c('aplayer',{attrs:{"music":{title: _vm.title, artist: _vm.artist, src: _vm.src, pic: _vm.cover},"theme":"#d0a95f","repeat":"no-repeat","preload":"auto"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }